import React, { useState, useEffect, useContext, useRef } from "react";
import { useSelector } from "react-redux";

// context
import { StateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import {
  CommunityList,
  CommunityPageSearchBar,
  AddCommunityButton,
  EmptyCommunityPage,
} from "./common";

// assets

// redux
import { RootState } from "bodycodi/cmap/app/redux/store";

// utils
import { api } from "../../js/api";

function CommunityPage() {
  const { dispatch } = useContext(DispatchContext);
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const pageRef = useRef<HTMLDivElement>(null);
  const { state } = useContext(StateContext);
  const [list, setList] = useState<Array<object>>([]);
  const [scrollEnd, setScrollEnd] = useState<any>(true);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [pagination, setPagination] = useState<any>({
    pageNo: 1,
    listSize: 10,
    loading: false,
  });

  const fetchCommunity = async (reset: boolean) => {
    dispatch({ type: "LOADING_START" });
    setPagination({ ...pagination, loading: true });
    const requestBody: any = {
      pageNo: reset ? 0 : pagination.pageNo * pagination.listSize,
      pageLimit: pagination.listSize,
      searchKeyword: searchTerm ? searchTerm : null,
    };

    await api
      .get("/community/posts", {
        params: { seqPartner, seqPartnerBranch, seqPartnerCoach, ...requestBody },
      })
      .then(({ data }: any) => {
        const result = data.posts;

        if (result.length > 0) {
          if (reset) {
            setList(result);
          } else {
            setList((prev) => [...prev, ...result]);
          }

          if (result.length < pagination.listSize) setScrollEnd(true);
          else setScrollEnd(false);
        } else {
          setScrollEnd(true);
          if (reset) setList([]);
        }
      })
      .finally(() => {
        if (reset) setPagination({ ...pagination, loading: false, pageNo: 1 });
        else setPagination({ ...pagination, loading: false, pageNo: pagination.pageNo + 1 });
        dispatch({ type: "LOADING_END" });
      });
  };

  useEffect(() => {
    fetchCommunity(true);
  }, [seqPartner, seqPartnerBranch, seqPartnerCoach, searchTerm, state.comunity.refresh]);

  if (!pagination.loading && searchTerm === "" && list.length === 0) return <EmptyCommunityPage />;
  else
    return (
      <div className="community-page" ref={pageRef}>
        <CommunityPageSearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

        <CommunityList
          loading={pagination.loading}
          fetchCommunity={fetchCommunity}
          list={list}
          listSize={pagination.listSize}
          scrollEnd={scrollEnd}
          setScrollEnd={setScrollEnd}
        />

        <AddCommunityButton />
      </div>
    );
}

export default CommunityPage;
